// src/order_status/TrackPage.js
import { useParams } from "react-router-dom";
import OrderStatus from "./OrderStatus";

const TrackPage = () => {
  const { id } = useParams(); // get orderID from URL
  return <OrderStatus orderID={id} />; // pass to your existing component
};

export default TrackPage;


